const garenaRegions = "sg ph th tw vn";

export const isGarenaLocale = (locale: string): boolean =>
  garenaRegions.indexOf(locale.split("-")[1]) > -1;
